import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType } from '@iotv/datamodel-core';
import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useObjectByTypeAndName } from '../../../hooks/useObjectByTypeAndName';
import { TabPanel } from '../../utils/TabPanelShim';
const debug = process.env.REACT_APP_DEBUG && false;
export const SelectionTab = ({ value, index, selectedDevices, setSelectedDevices, setReceivedDeviceControlTransactions }) => {
    const { components: { objectTypeSelector, entitySelector }, state: { currentEntity: [searchedDevice, setSearchedDevice], objectTypeState, }, } = useObjectByTypeAndName({
        contextObject: undefined,
        adjacencyType: AdjacentType.SUBJECT,
        currentObject: selectedDevices[0],
        currentObjectTypeId: 'Device',
        validTypeIds: ['Device'],
    });
    debug && console.log('selectedDevices', selectedDevices, entitySelector);
    useEffect(() => {
        if (searchedDevice) {
            setSelectedDevices([searchedDevice]);
        }
    }, [searchedDevice?.sk]);
    return (_jsx(TabPanel, { value, index, children: _jsx(Grid, { container: true, children: _jsxs(Grid, { size: 6, children: [_jsx(Typography, { children: "Search Devices" }), entitySelector] }, 'deviceSearch') }) }));
};
